import React, {Component} from 'react';

class FacebookShare extends Component {

  componentDidMount() {
    (function (d, s, id) {
      if (window.FB) {
        window.FB.XFBML.parse();
      }
      else {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.12&appId=2024228914514635&autoLogAppEvents=1';
        fjs.parentNode.insertBefore(js, fjs);
      }
    }(document, 'script', 'facebook-jssdk'));
  }

  render() {
    return (
      <div className="fb-share-button" data-layout="button" data-size="large" data-mobile-iframe="true">
        <a target="_blank" className="fb-xfbml-parse-ignore"
           href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&amp;src=sdkpreparse">
          Share</a>
      </div>
    );
  }
}

export default FacebookShare;


// WEBPACK FOOTER //
// ./src/components/FacebookShare.js